import { OnInit, Component } from '@angular/core';
import { ConfirmService } from "./confirm.service";
import translateJson from "../../../translate.json";

const KEY_ESC = 27;

enum messageType {Confirm, Info, Success, Error, ConfirmHtml};

@Component({
    selector: 'modal-confirm',
    templateUrl: './confirm.component.html',
    styleUrls: ['./confirm.component.css']
})

export class ConfirmComponent implements OnInit {

    private i18 = translateJson.i18;
    private defaults = {
        title: this.i18.modals.confirmModal.title,
        message: this.i18.modals.confirmModal.messageContinue,
        cancelText: this.i18.modals.confirmModal.cancelButton,
        okText: this.i18.modals.confirmModal.okButton
    };    

    title: string;
    message: string;
    okText: string;
    cancelText: string;
    type: any;
    private readyToClose: boolean = false

    private confirmElement:any;
    private cancelButton:any;
    private okButton:any;

    constructor(confirmService:ConfirmService) { 
        confirmService.confirm = this.confirm.bind(this);
        confirmService.info = this.info.bind(this);
        confirmService.success = this.success.bind(this);
        confirmService.error = this.error.bind(this);
        confirmService.confirmHtml = this.confirmHtml.bind(this);
    }    

    confirm(message = this.defaults.message) {
        this.type = messageType.Confirm;
        this.message = message;
        this.okText = this.defaults.okText;
        this.cancelText = this.defaults.cancelText;
        let promise = new Promise<boolean>(resolve => {
            this.show(resolve);
        });
        return promise;
    }

    info(message = this.defaults.message, title = this.defaults.title) {
        this.title = title;
        this.message = message;
        this.okText = this.defaults.okText;
        this.cancelText = this.defaults.cancelText;

        let promise = new Promise<boolean>(resolve => {
            this.show(resolve);
        });
        return promise;
    }

    success(message = this.defaults.message) {        
        this.type = messageType.Success;
        this.message = message;
        this.okText = this.defaults.okText;
        let promise = new Promise<boolean>(resolve => {
            this.show(resolve);
        });
        return promise;
    }

    error(message = this.defaults.message) {        
        this.type = messageType.Error;
        this.message = message;
        this.okText = this.defaults.okText;
        let promise = new Promise<boolean>(resolve => {
            this.show(resolve);
        });
        return promise;
    } 
    
    confirmHtml(message, okText, cancelText) {
        this.type = messageType.ConfirmHtml;
        this.message = message === null ? this.defaults.message : message;
        this.okText = okText === null ? this.defaults.okText : okText
        this.cancelText = cancelText === null ? this.defaults.cancelText : cancelText
        let promise = new Promise<boolean>(resolve => {
            this.show(resolve);
        });
        return promise;
    }

    private show(resolve:(boolean) => any) {
        document.onkeyup = null;
        this.readyToClose = false;

        let negativeOnClick = (e:any) => resolve(false);
        let positiveOnClick = (e:any) => resolve(true);        

        this.confirmElement.style.opacity = 0;
        this.confirmElement.style.zIndex = 2010;

        if (this.type == 1) {
            this.cancelButton.onclick = ((e:any) => {
                e.preventDefault();
                if (!negativeOnClick(e)) this._hideDialog();
            })
        }        

        this.okButton.onclick = ((e:any) => {
            e.preventDefault();
            if (!positiveOnClick(e)) this._hideDialog()
        });

        this.confirmElement.onclick = () => {
            this._hideDialog();
            return negativeOnClick(null);
        };

        document.onkeyup = (e:any) => {
            if (e.which == KEY_ESC) {
                this._hideDialog();
                return negativeOnClick(null);
            }
        };

        this.confirmElement.style.opacity = 1;
    }

    private _hideDialog() {
        this.readyToClose = true;
        document.onkeyup = null;
        this.confirmElement.style.opacity = 0;
        window.setTimeout(() => {
            if(this.readyToClose){
                this.confirmElement.style.zIndex = -1
            }
        }, 400);
    }

    ngOnInit():any {
        this.confirmElement = document.getElementById('confirmationModal');
        this.cancelButton = document.getElementById('cancelButton');
        this.okButton = document.getElementById('okButton');
    }
}